

import templateBookingDetailPage from '@/app-template/lib/pages/BookingDetailPage.vue';

export default {
  name: "BookingDetailPage",
  components: { templateBookingDetailPage },
};
